<template>
  <Layout class="mt-20">
    <Description />

    <AdminOnly>
      <FeedbackMessage :feedback="feedback" :resetFeedback="resetFeedback" />
      <div class="inline-block" @click="handleClick">
        <p
          class="
            flex
            rounded-md
            border border-gray-300
            shadow-sm
            px-4
            py-2
            bg-white
            text-md
            font-medium
            text-gray-700
            hover:bg-gray-50
            focus:outline-none
            cursor-pointer
          "
        >
          Upload new job posting
        </p>
      </div>
    </AdminOnly>

    <LoadingSpinner v-if="loading.display" :message="loading.message" />
    <JobPostings v-else :careersFiles="directory.careers" />

    <div v-if="noCareers">
      <p class="text-xl">There are currently no job openings</p>
    </div>

    <p class="font-AvenirFont lg:text-lg text-md mt-56 mb-16">
      Don't see anything that interests you? We are always on the look-out for
      great talent, so let us know what you're passionate about by applying
      <a
        href="https://docs.google.com/forms/d/e/1FAIpQLScAicjPnnVyvTZRaO3Khynm_y8yWJ7-n_rNesxojEYHSBrO1g/viewform"
        target="_blank"
        class="uppercase hover:underline text-STorange"
        >here</a
      >.
    </p>
  </Layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Description from './Description.vue'
import JobPostings from './JobPostings.vue'
import AdminOnly from '../AdminOnly.vue'
import LoadingSpinner from '../LoadingSpinner.vue'
import FeedbackMessage from '../FeedbackMessage.vue'
import Layout from '../Layout.vue'
import initData from '../../mixins/initData'
import loader from '../../mixins/loader'

export default {
  name: 'Careers',
  mixins: [initData, loader],

  components: {
    Description,
    JobPostings,
    LoadingSpinner,
    AdminOnly,
    FeedbackMessage,
    Layout,
  },

  computed: {
    ...mapGetters(['feedback', 'directory', 'careersID']),

    noCareers() {
      return this.directory.careers.length === 0
    },
  },

  methods: {
    ...mapActions(['resetFeedback']),

    handleClick() {
      this.$router.push({
        name: 'UploadNewFile',
        params: { path: 'job posting' },
      })
    },
  },

  async created() {
    if (this.noCareers) {
      this.load(this.initData(this.careersID), 'Loading careers')
    }
  },
}
</script>
